import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { HistorialTrasladosApi } from "../api/HistorialTrasladosApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosTraslados } from "./FiltrosTraslados";
import { TrasladosTable } from "./TrasladosTable";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";

export const Listado = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [traslados, setTraslados] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getTraslados, cargando } = HistorialTrasladosApi();

    const GetTraslados = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getTraslados(params);
            setTraslados(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los traslados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setTraslados([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetTraslados();
    }, [paginaSeleccionada]);

    useEffect(() => {
        GetTraslados();
    }, [fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [fecha_inicial, fecha_final, paginaSeleccionada]);

    return (
        <div className="historial-control-calidad__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="historial-control-calidad__table-header">
                        <FiltrosTraslados
                            control={control}
                            onRefresh={() => {
                                GetTraslados();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                        />
                        <Link to={`/produccion-bodega/crear-control-calidad`}>
                            <button className="btn btn-primary">
                                Crear Traslado
                            </button>
                        </Link>
                    </div>

                    <TrasladosTable traslados={traslados} />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
